var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccessErrorBase',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(" Error ")]},proxy:true},{key:"errorTitle",fn:function(){return [_vm._v(" Error loading sites ")]},proxy:true},{key:"errorText",fn:function(){return [_vm._v(" "+_vm._s(_vm.siteLoadError)+" ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }